import { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router';
import { Login } from './client/pages/Login';
import { Portal } from './client/pages/Portal';
import { DashboardView } from './client/pages/DashboardView';
import { apiFetch } from './client/lib/api';

function AuthGate({ children }: { children: React.ReactNode }) {
  const [status, setStatus] = useState<'loading' | 'authenticated' | 'unauthenticated'>('loading');

  useEffect(() => {
    apiFetch<{ authenticated: boolean }>('/auth/session')
      .then((res) => setStatus(res.authenticated ? 'authenticated' : 'unauthenticated'))
      .catch(() => setStatus('unauthenticated'));
  }, []);

  if (status === 'loading') {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-gray-300 border-t-black" />
      </div>
    );
  }

  if (status === 'unauthenticated') {
    return <Login />;
  }

  return <>{children}</>;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthGate>
        <div className="flex flex-col min-h-screen bg-gray-50">
          <Routes>
            <Route path="/" element={<Portal />} />
            <Route path="/dashboard/:id" element={<DashboardView />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </AuthGate>
    </BrowserRouter>
  );
}
